<app-grid
  stateKey="UserRoles"
  [columnDefs]="columnDefs"
  [rowData]="rowData$ | async"
  [showDelete]="false"
  (save)="save()"
>
</app-grid>
